<template>
  <div class="Websitebuilding">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div class="page-Websitebuilding">
          <div class="img">
            <img src="../../assets/images/img-Websitebuilding.png" alt>
          </div>
           <p class="title">功能正在建设中</p>
        </div>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import axios from 'axios'
export default {
  name: "Websitebuilding",
  data() {
    return {
      openMenu: ["1"],
			time: 5,
			original_token: '',
			staffer_id: ''
    };
  },
  components: {
    PageNav
  },
  created() {
		this.token = this.$route.query.token
		this.staffer_id = this.$route.query.staffer_id
    // 
    this.slider = this.$store.state.Slider;
  },
  mounted() {},
  methods: {
  }
};
</script>
<style lang="less">
.Websitebuilding {
    height: 100vh;
  // height: calc(100% - 60px);
  font-size: 20px;
  .el-main{
     background: #F1F4FA;
  }
  .el-aside {
    display: none;
  }
}
.page-Websitebuilding {
  text-align: center;
  padding-top: 15%;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 600;
    color: #333;
    line-height: 37px;
  }
  .img {
    width: 300px;
    background: #F1F4FA;
    margin: 30px auto 20px auto;
    padding: 30px 30px;
    // border: 1px dashed #ddd;
    img {
      width: 100%;
    }
  }
}
</style>
